import { createContext, Dispatch, SetStateAction } from 'react';
import NavigationContent from '@modules/utilities/interfaces/NavigationContent';
import NavigationBackTo from '@modules/utilities/interfaces/NavigationBackTo';
import TreeNode from './interfaces/TreeNode';
import { BreadcrumbItem } from './components/PageBreadcrumbs';
import { SingleSelectTreeViewState } from './components/Tree';

export type TTreeListData = { heading: string | null; nodes: TreeNode[] }[];
export type SideBarContentType = SingleSelectTreeViewState & {
  hasEngineClasses: boolean;
  hasLeftNav: boolean; // determines layout centering styles
  setHasLeftNav: Dispatch<SetStateAction<boolean>>;
  content?: NavigationContent[];
  backTo?: NavigationBackTo;
  open: boolean;
  setExpanded: Dispatch<SetStateAction<string[]>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setSelected: Dispatch<SetStateAction<string>>;
  treeListData: TTreeListData;
  getBreadcrumbsItems: (translate: (key: string) => string) => BreadcrumbItem[] | null;
  sidebarSessionId: string;
  resetSidebarSessionId: () => void;
};

const SideBarContentContext = createContext<SideBarContentType>({
  hasEngineClasses: false,
  hasLeftNav: false,
  setHasLeftNav: () => {
    throw new Error('Not implemented');
  },
  content: undefined,
  backTo: undefined,
  expanded: [],
  selected: '',
  treeListData: [],
  open: true,
  setExpanded: () => {
    throw new Error('Not implemented');
  },
  setOpen: () => {
    throw new Error('Not implemented');
  },
  setSelected: () => {
    throw new Error('Not implemented');
  },
  getBreadcrumbsItems: () => {
    throw new Error('Not implemented');
  },
  sidebarSessionId: '',
  resetSidebarSessionId: () => {
    throw new Error('Not implemented');
  },
});
SideBarContentContext.displayName = 'SideBarContent';

export default SideBarContentContext;
